import { render, staticRenderFns } from "./petty_cash_apply.vue?vue&type=template&id=b46af360"
import script from "./petty_cash_apply.vue?vue&type=script&lang=js"
export * from "./petty_cash_apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports